import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NetworkHelper } from '../helpers';
import { Observable } from 'rxjs';
import { SHARED_ENV } from '../tokens';

@Injectable({ providedIn: 'root' })
export class TFAService {
  private readonly env = inject(SHARED_ENV);
  private readonly networkHelper = inject(NetworkHelper);

  hostUrl: string;

  constructor() {
    this.hostUrl = this.env.host;
  }

  generate(): Observable<any> {
    return this.networkHelper.post(`${this.hostUrl}/tfa/generate`, {});
  }

  verify(token: string): Observable<any> {
    return this.networkHelper.post(`${this.hostUrl}/tfa/verify`, {
      token: token,
    });
  }

  disable(token: string): Observable<any> {
    return this.networkHelper.post(`${this.hostUrl}/tfa/disable`, {
      token: token,
    });
  }

  disableForUser(userId: string): Observable<any> {
    return this.networkHelper.post(`${this.hostUrl}/tfa/disable/${userId}`, {});
  }

  skip(): Observable<any> {
    return this.networkHelper.post(`${this.hostUrl}/tfa/skip`, {});
  }
}
